module.exports = __webpack_public_path__ + "onboarding-feed-localdirectory.bf728d4d1df118a1673c31650349b125.hashedasset.svg";


//////////////////
// WEBPACK FOOTER
// ./app/img/library/empty/onboarding-feed-localdirectory.svg
// module id = 1794023705296712
// module chunks = 1